import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse,
} from '@angular/common/http';
import { catchError, switchMap, take } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { includes } from 'lodash';
import { AuthenticationService } from './authentication.service';
import { Store } from '@ngrx/store';
import { AppState } from 'app/app.reducer';

@Injectable()
export class AuthenticationInterceptor implements HttpInterceptor {
  constructor(
    private authenticationService: AuthenticationService,
    private store: Store<AppState>
  ) {}

  addHeaders(
    req: HttpRequest<any>,
    projectId?: number,
    includeToken = false
  ): HttpRequest<any> {
    const headers: { [name: string]: string } = {};

    if (includeToken) {
      headers.Authorization = `Bearer ${this.authenticationService.getToken()}`;
    }

    if (projectId !== null && projectId !== undefined) {
      headers['X-Project-Id'] = projectId.toString();
    }

    return req.clone({
      setHeaders: headers,
    });
  }

  shouldSkipAuthentication(req: HttpRequest<any>): boolean {
    return [
      '/secure/token',
      '/oauth',
      '/reset',
      '/password',
      '/forgetPassword',
      '/public'
    ].some(path => includes(req.url, path));
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return this.store.select('project').pipe(
      take(1),
      switchMap(({ projectId }) => {
        if (this.shouldSkipAuthentication(req)) {
          return next.handle(this.addHeaders(req, projectId));
        }

        if (this.authenticationService.isAuthenticated()) {
          return next.handle(this.addHeaders(req, projectId, true)).pipe(
            catchError((err) => {
              if (err instanceof HttpErrorResponse && err.status === 401) {
                this.authenticationService.goAuth0Login(null, 'logout');
                return null;
              } else {
                return throwError(err);
              }
            })
          );
        } else {
          this.authenticationService.goAuth0Login(null, 'logout');
          return null;
        }
      })
    );
  }
}
